import Pathes from '@/helpers/pathes';
import axios from '@/axios-api';
import { getQuery } from '@/helpers/utils';

export const blogService = {
  articles: params => axios.get(Pathes.Blog.articles + getQuery(params)),
  article: slug => axios.get(Pathes.Blog.article(slug)),
  banners: () =>
    axios.get(Pathes.Blog.articles + getQuery({ page: 1, limit: 3 })),
};
